import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEsFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53839)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.863573 41.3797H49.1394C49.6154 41.3797 50.0015 40.9937 50.0015 40.5176V9.4832C50.0015 9.00713 49.6154 8.62109 49.1394 8.62109H0.863573C0.387499 8.62119 0.00146484 9.00713 0.00146484 9.4832V40.5176C0.00146484 40.9938 0.387499 41.3797 0.863573 41.3797Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0014 15.5176H0.00146484V34.4834H50.0014V15.5176Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.1221 25.0005L21.853 21.7113C21.9204 21.4084 21.6898 21.1211 21.3795 21.1211H20.8646C20.5544 21.1211 20.3239 21.4084 20.3911 21.7113L21.1221 25.0005Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.9844 23.2754H20.2603V30.6025H21.9844V23.2754Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4148 22.4141H19.8286V23.2762H22.4148V22.4141Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.417 25H18.1064V25.8621H22.417V25Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4168 28.4487L19.8306 27.5867V26.7246L22.4168 27.5867V28.4487Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.19286 25.0005L8.92381 21.7113C8.9912 21.4084 8.76063 21.1211 8.45028 21.1211H7.93544C7.62518 21.1211 7.39472 21.4084 7.4619 21.7113L8.19286 25.0005Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.2088 22.4141C10.7327 22.4141 10.3467 22.8001 10.3467 23.2762V28.8796C10.3467 29.9269 11.3242 31.8969 14.657 31.8969C17.9898 31.8969 18.9674 29.927 18.9674 28.8796V23.2762C18.9674 22.8001 18.5813 22.4141 18.1053 22.4141H11.2088Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6585 26.7244H10.3481V23.2762C10.3481 22.8001 10.7342 22.4141 11.2103 22.4141H14.6585V26.7244Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6587 26.7246H18.969V28.8798C18.969 30.0701 18.0042 31.035 16.8139 31.035C15.6235 31.035 14.6587 30.0701 14.6587 28.8798V26.7246Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.3467 26.7246H14.657V28.8798C14.657 30.0701 13.6922 31.035 12.5019 31.035C11.3115 31.035 10.3467 30.0701 10.3467 28.8798V26.7246Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7933 30.5942V26.7246H12.9312V30.9915C13.2519 30.9265 13.5416 30.7845 13.7933 30.5942Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0691 30.9915V26.7246H11.207V30.5942C11.4588 30.7845 11.7485 30.9265 12.0691 30.9915Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7947 25H11.2085V25.8621H13.7947V25Z",
					fill: "#FFB441"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7947 23.2754H11.2085V24.1375H13.7947V23.2754Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.3628 23.7881H11.6387V25.3498H13.3628V23.7881Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.05273 23.2754H7.32861V30.6025H9.05273V23.2754Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.48271 30.1729H6.89648V31.035H9.48271V30.1729Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.48271 22.4141H6.89648V23.2762H9.48271V22.4141Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.91552 31.0342H6.46729V31.8963H9.91552V31.0342Z",
					fill: "#5064AA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.8465 30.1729H20.2603V31.035H22.8465V30.1729Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.8462 31.0342H19.3979V31.8963H22.8462V31.0342Z",
					fill: "#5064AA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.2433 21.5518H12.0708V22.4139H17.2433V21.5518Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.0882 18.9658H14.2261V21.552H15.0882V18.9658Z",
					fill: "#FFB441"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7945 20.259C13.0814 20.259 12.5015 19.6789 12.5015 18.9659C12.5015 18.2528 13.0815 17.6729 13.7945 17.6729C14.5076 17.6729 15.0876 18.2529 15.0876 18.9659C15.0877 19.6789 14.5076 20.259 13.7945 20.259ZM13.7945 18.5349C13.5567 18.5349 13.3635 18.728 13.3635 18.9659C13.3635 19.2037 13.5566 19.397 13.7945 19.397C14.0324 19.397 14.2256 19.2038 14.2256 18.9659C14.2256 18.7281 14.0324 18.5349 13.7945 18.5349Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5186 20.259C14.8056 20.259 14.2256 19.6789 14.2256 18.9659C14.2256 18.2528 14.8057 17.6729 15.5186 17.6729C16.2317 17.6729 16.8117 18.2529 16.8117 18.9659C16.8117 19.6789 16.2316 20.259 15.5186 20.259ZM15.5186 18.5349C15.2809 18.5349 15.0876 18.728 15.0876 18.9659C15.0876 19.2037 15.2808 19.397 15.5186 19.397C15.7564 19.397 15.9497 19.2038 15.9497 18.9659C15.9496 18.7281 15.7564 18.5349 15.5186 18.5349Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.2433 21.1213C16.5302 21.1213 15.9502 20.5412 15.9502 19.8282C15.9502 19.1151 16.5303 18.5352 17.2433 18.5352C17.9563 18.5352 18.5363 19.1152 18.5363 19.8282C18.5363 20.5412 17.9562 21.1213 17.2433 21.1213ZM17.2433 19.3972C17.0055 19.3972 16.8122 19.5903 16.8122 19.8282C16.8122 20.066 17.0054 20.2593 17.2433 20.2593C17.4811 20.2593 17.6743 20.0661 17.6743 19.8282C17.6743 19.5903 17.4811 19.3972 17.2433 19.3972Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0704 21.1213C11.3573 21.1213 10.7773 20.5412 10.7773 19.8282C10.7773 19.1151 11.3574 18.5352 12.0704 18.5352C12.7835 18.5352 13.3635 19.1152 13.3635 19.8282C13.3636 20.5412 12.7835 21.1213 12.0704 21.1213ZM12.0704 19.3972C11.8326 19.3972 11.6394 19.5903 11.6394 19.8282C11.6394 20.066 11.8325 20.2593 12.0704 20.2593C12.3083 20.2593 12.5015 20.066 12.5015 19.8281C12.5015 19.5903 12.3083 19.3972 12.0704 19.3972Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.2428 28.4479V28.879C17.2428 29.1167 17.0494 29.3101 16.8117 29.3101C16.574 29.3101 16.3807 29.1167 16.3807 28.879V28.4479H17.2428ZM18.1048 27.5859H15.5186V28.879C15.5186 29.5921 16.0986 30.1721 16.8116 30.1721C17.5247 30.1721 18.1047 29.592 18.1047 28.879V27.5859H18.1048Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.8123 25.8627C16.3362 25.8627 15.9502 25.4767 15.9502 25.0006V24.1385C15.9502 23.6624 16.3362 23.2764 16.8123 23.2764C17.2884 23.2764 17.6744 23.6624 17.6744 24.1385V25.0006C17.6744 25.4767 17.2884 25.8627 16.8123 25.8627Z",
					fill: "#FFA0D2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6568 28.0168C15.371 28.0168 15.9499 27.4379 15.9499 26.7237C15.9499 26.0096 15.371 25.4307 14.6568 25.4307C13.9427 25.4307 13.3638 26.0096 13.3638 26.7237C13.3638 27.4379 13.9427 28.0168 14.6568 28.0168Z",
					fill: "#5064AA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.0882 17.2412H14.2261V19.8274H15.0882V17.2412Z",
					fill: "#FAB446"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.0701 21.552L11.208 20.6899L11.713 20.185C12.4936 19.4044 13.5523 18.9658 14.6563 18.9658C15.7603 18.9658 16.819 19.4044 17.5997 20.185L18.1047 20.6899L17.2426 21.552H12.0701Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6557 21.1209C14.8937 21.1209 15.0867 20.9279 15.0867 20.6898C15.0867 20.4518 14.8937 20.2588 14.6557 20.2588C14.4176 20.2588 14.2246 20.4518 14.2246 20.6898C14.2246 20.9279 14.4176 21.1209 14.6557 21.1209Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9311 21.1209C13.1691 21.1209 13.3621 20.9279 13.3621 20.6898C13.3621 20.4518 13.1691 20.2588 12.9311 20.2588C12.693 20.2588 12.5 20.4518 12.5 20.6898C12.5 20.9279 12.693 21.1209 12.9311 21.1209Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3793 21.1209C16.6174 21.1209 16.8103 20.9279 16.8103 20.6898C16.8103 20.4518 16.6174 20.2588 16.3793 20.2588C16.1412 20.2588 15.9482 20.4518 15.9482 20.6898C15.9482 20.9279 16.1412 21.1209 16.3793 21.1209Z",
					fill: "#FFD250"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.207 25H6.89648V25.8621H11.207V25Z",
					fill: "#C8414B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.89648 28.4478L9.48261 27.5857V26.7236L6.89648 27.5857V28.4478Z",
					fill: "#C8414B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53839",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEsFlag);
export { ForwardRef as ReactComponent };
